// extracted by mini-css-extract-plugin
export default {"container":"errorboundary_container__8oAw2"};